(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feedback-shop-story"] && !Shopify.designMode) return;
  try {
    
class SenShopStory extends HTMLElement {
 connectedCallback() {
  const root = this;
  const slides = [...root.querySelectorAll('[data-story-slide]')];
  if (slides.length < 2 || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  let active = 0;
  let animations = [];
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  root.querySelectorAll('.sen-shop-story__image img').forEach((image) => {
    const visual = image.parentElement;
    if (image.complete) return;
    visual.classList.add('is-loading');
    const finish = () => visual.classList.remove('is-loading');
    image.addEventListener('load', finish, { once: true });
    image.addEventListener('error', finish, { once: true });
  });
  const render = (next, direction = 0, focus = false) => {
    animations.forEach((animation) => animation.cancel());
    animations = [];
    const previous = active;
    active = next;
    slides.forEach((slide, index) => {
      slide.hidden = index !== active;
      slide.inert = false;
      slide.classList.remove('is-transitioning');
      const controls = slide.querySelector('.sen-shop-story__controls');
      if (controls) controls.hidden = false;
      const count = slide.querySelector('[data-story-count]');
      if (count) count.textContent = `${active + 1} / ${slides.length}`;
      const progress = slide.querySelector('[data-story-progress]');
      if (progress) progress.style.width = `${(active + 1) / slides.length * 100}%`;
    });
    if (direction && previous !== active && !reducedMotion.matches && slides[active].animate) {
      const outgoing = slides[previous];
      const incoming = slides[active];
      outgoing.hidden = false;
      outgoing.classList.add('is-transitioning');
      outgoing.inert = true;
      animations = [
        outgoing.animate([{ transform: 'translateX(0)' }, { transform: `translateX(${-direction * 100}%)` }], { duration: 1100, easing: 'cubic-bezier(.45,0,.2,1)', fill: 'both' }),
        incoming.animate([{ transform: `translateX(${direction * 100}%)` }, { transform: 'translateX(0)' }], { duration: 1100, easing: 'cubic-bezier(.45,0,.2,1)' })
      ];
      animations[0].finished.then(() => { outgoing.hidden = true; outgoing.inert = false; outgoing.classList.remove('is-transitioning'); }).catch(() => {});
    }
    if (focus) slides[active].querySelector(direction > 0 ? '[data-story-next]' : '[data-story-prev]')?.focus({ preventScroll: true });
  };
  root.addEventListener('click', (event) => {
    const button = event.target.closest('[data-story-prev], [data-story-next]');
    if (!button) return;
    const direction = button.hasAttribute('data-story-next') ? 1 : -1;
    render((active + direction + slides.length) % slides.length, direction, true);
  });
  root.addEventListener('shopify:block:select', (event) => {
    const index = slides.indexOf(event.target.closest('[data-story-slide]'));
    if (index >= 0) render(index);
  });
  render(0);
 }
}
if (!customElements.get('sen-shop-story')) customElements.define('sen-shop-story', SenShopStory);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feedback-slider"] && !Shopify.designMode) return;
  try {
    
function initFeedbackSlider(slider) {
  if (!slider || slider.dataset.initialized) return;
  slider.dataset.initialized = 'true';
  const slides = Array.from(slider.querySelectorAll('[data-slide]'));
  if (slides.length < 2) return;
  let current = 0, timer, locked = false, startX = null, startY = 0, pointerId = null, dragging = false, suppressClick = false;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const paint = (slide, position) => {
    slide.style.setProperty('--slide-x', `${position * 100}%`);
    slide.style.setProperty('--media-x', `${-position * 100}%`);
    slide.style.setProperty('--content-x', `${-position * 30}%`);
    slide.style.setProperty('--content-opacity', String(Math.max(0, 1 - Math.abs(position))));
  };
  const accessibility = () => slides.forEach((slide, i) => { const active = i === current; slide.classList.toggle('is-active', active); slide.toggleAttribute('inert', !active); slide.setAttribute('aria-hidden', String(!active)); });
  const stop = () => clearTimeout(timer);
  const start = () => { stop(); if (slider.dataset.autoplay === 'true' && !reduced.matches && !document.hidden && !slider.matches(':hover, :focus-within')) timer = setTimeout(() => move(1), Number(slider.dataset.interval)); };
  const move = (direction, fromDrag = false) => {
    if (locked) return;
    stop(); locked = true;
    const previous = current, next = (current + direction + slides.length) % slides.length;
    if (!fromDrag) { slider.classList.add('is-dragging'); paint(slides[next], direction); slides[next].offsetWidth; }
    slider.classList.remove('is-dragging');
    requestAnimationFrame(() => { paint(slides[previous], -direction); paint(slides[next], 0); });
    current = next; accessibility();
    setTimeout(() => { locked = false; start(); }, reduced.matches ? 0 : 1000);
  };
  slider.querySelector('[data-next]').addEventListener('click', () => move(1));
  slider.querySelector('[data-prev]').addEventListener('click', () => move(-1));
  const area = slider.querySelector('.feedback-slider__slides');
  if (slider.dataset.drag === 'false') area.style.cursor = 'default';
  area.addEventListener('dragstart', (event) => event.preventDefault());
  area.addEventListener('pointerdown', (event) => { if (slider.dataset.drag === 'false' || locked || pointerId !== null || !event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return; startX = event.clientX; startY = event.clientY; pointerId = event.pointerId; dragging = false; suppressClick = false; });
  area.addEventListener('pointermove', (event) => {
    if (startX === null || event.pointerId !== pointerId || locked) return;
    const dx = event.clientX - startX, dy = event.clientY - startY;
    if (!dragging && (Math.abs(dx) < 8 || Math.abs(dx) < Math.abs(dy))) return;
    if (!dragging) { dragging = true; stop(); slider.classList.add('is-dragging'); area.setPointerCapture(event.pointerId); }
    const progress = Math.max(-1, Math.min(1, dx / area.clientWidth));
    const direction = progress < 0 ? 1 : -1, next = (current + direction + slides.length) % slides.length;
    paint(slides[current], progress); paint(slides[next], direction + progress);
  });
  const release = (event) => {
    if (startX === null || event.pointerId !== pointerId) return;
    const dx = event.clientX - startX; startX = null; pointerId = null;
    if (!dragging) return;
    dragging = false; suppressClick = Math.abs(dx) > 8;
    if (event.type !== 'pointercancel' && Math.abs(dx) > Math.min(100, area.clientWidth * .18)) move(dx < 0 ? 1 : -1, true);
    else { slider.classList.remove('is-dragging'); paint(slides[current], 0); paint(slides[(current + 1) % slides.length], dx < 0 ? 1 : -1); start(); }
  };
  area.addEventListener('pointerup', release); area.addEventListener('pointercancel', release);
  area.addEventListener('click', (event) => { if (suppressClick) { event.preventDefault(); event.stopPropagation(); suppressClick = false; } }, true);
  slider.addEventListener('mouseenter', stop); slider.addEventListener('mouseleave', start);
  slider.addEventListener('focusin', stop); slider.addEventListener('focusout', (event) => { if (!slider.contains(event.relatedTarget)) start(); });
  document.addEventListener('visibilitychange', start);
  slider.addEventListener('shopify:block:select', (event) => { const index = slides.indexOf(event.target.closest('[data-slide]')); if (index >= 0 && index !== current) move(1); stop(); });
  slider.addEventListener('shopify:block:deselect', start);
  accessibility(); start();
}
let feedbackRatingsObserver;
function initFeedbackRatings() {
  if (feedbackRatingsObserver) feedbackRatingsObserver.disconnect();
  const targets = document.querySelectorAll('[data-feedback-rating]');
  const reviews = document.querySelector('.feedback-judge-reviews');
  if (!targets.length || !reviews) return;
  const update = () => {
    const average = reviews.querySelector('.jdgm-all-reviews__summary-average');
    const count = reviews.querySelector('.jdgm-all-reviews__summary-text');
    const value = average && parseFloat(average.textContent.trim().replace(',', '.'));
    const countText = count && count.textContent.trim();
    const countNumber = countText && countText.match(/\d[\d,.]*/);
    const total = countNumber && Number(countNumber[0].replace(/[,.]/g, ''));
    targets.forEach((target) => {
      if (!Number.isFinite(value) || value <= 0 || value > 5 || !total) { target.hidden = true; return; }
      target.querySelector('[data-rating-value]').textContent = value.toFixed(1);
      target.querySelector('[data-rating-stars]').style.width = `${value / 5 * 100}%`;
      target.querySelector('[data-rating-count]').textContent = countText;
      target.setAttribute('aria-label', `${value.toFixed(1)} out of 5. ${countText}`);
      target.hidden = false;
    });
  };
  update();
  feedbackRatingsObserver = new MutationObserver(update);
  feedbackRatingsObserver.observe(reviews, { childList: true, subtree: true, characterData: true });
}
initFeedbackRatings();
function updateFeedbackHeader() {
  if (!document.querySelector('[data-feedback-slider]')) return;
  const announcement = document.querySelector('.announcement-bar-section');
  const update = () => document.body.style.setProperty('--feedback-announcement-height', `${announcement ? announcement.getBoundingClientRect().height : 0}px`);
  update();
  if (announcement && 'ResizeObserver' in window) new ResizeObserver(update).observe(announcement);
  const banner = document.querySelector('[data-feedback-slider]');
  const updateSticky = () => document.body.classList.toggle('feedback-header-scrolled', banner.getBoundingClientRect().bottom <= 0);
  window.addEventListener('scroll', updateSticky, { passive: true });
  updateSticky();
}
updateFeedbackHeader();
document.querySelectorAll('[data-feedback-slider]').forEach(initFeedbackSlider);
document.addEventListener('shopify:section:load', (event) => { const slider = event.target.querySelector('[data-feedback-slider]'); if (slider) { initFeedbackSlider(slider); initFeedbackRatings(); } });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('click', async (event) => {
    const localeButton = event.target.closest('[data-sen-open-localization]');
    if (localeButton) {
      const drawer = localeButton.closest('.sen-header')?.querySelector('header-drawer');
      const menu = drawer?.querySelector('details.menu-drawer-container');
      if (menu && !menu.open) drawer.querySelector('summary.header__icon--menu')?.click();
      setTimeout(() => {
        const selector = drawer?.querySelector('.menu-drawer__localization .localization-form__select');
        selector?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        selector?.focus({ preventScroll: true });
      }, 250);
      return;
    }

    const dialog = document.querySelector('[data-sen-header-wishlist]');
    if (!dialog) return;
    if (event.target.closest('[data-sen-header-wishlist-close]')) {
      dialog.close();
      return;
    }

    const removeButton = event.target.closest('[data-sen-header-wishlist-remove]');
    if (removeButton) {
      try {
        const saved = JSON.parse(localStorage.getItem('the-sen:wishlist:v1') || '[]');
        localStorage.setItem('the-sen:wishlist:v1', JSON.stringify(saved.filter((handle) => handle !== removeButton.dataset.senHeaderWishlistRemove)));
      } catch {}
      removeButton.closest('.sen-shop-card')?.remove();
      if (!dialog.querySelector('[data-sen-header-wishlist-items]').children.length) {
        dialog.querySelector('[data-sen-header-wishlist-status]').textContent = JSON.parse(dialog.querySelector('[data-sen-header-wishlist-labels]').textContent).empty;
      }
      return;
    }

    if (!event.target.closest('[data-sen-wishlist-open]') || document.querySelector('sen-product-ui')) return;
    const labels = JSON.parse(dialog.querySelector('[data-sen-header-wishlist-labels]').textContent);
    const status = dialog.querySelector('[data-sen-header-wishlist-status]');
    const items = dialog.querySelector('[data-sen-header-wishlist-items]');
    let saved = [];
    try {
      const values = JSON.parse(localStorage.getItem('the-sen:wishlist:v1') || '[]');
      if (Array.isArray(values)) saved = values.filter((handle) => typeof handle === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(handle)).slice(0, 50);
    } catch {}
    items.replaceChildren();
    status.textContent = saved.length ? labels.loading : labels.empty;
    dialog.showModal();
    if (!saved.length) return;

    const root = window.Shopify?.routes?.root || '/';
    const cards = await Promise.all(saved.map(async (handle) => {
      try {
        const response = await fetch(`${root}products/${encodeURIComponent(handle)}?section_id=sen-product-tile`);
        if (!response.ok) return null;
        const html = await response.text();
        const card = new DOMParser().parseFromString(html, 'text/html').querySelector('.sen-shop-card');
        if (!card) return null;
        card.querySelector('[data-sen-wishlist]')?.remove();
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'sen-header-wishlist__remove';
        remove.dataset.senHeaderWishlistRemove = handle;
        remove.textContent = labels.remove;
        card.append(remove);
        return card;
      } catch { return null; }
    }));
    if (!dialog.open) return;
    items.replaceChildren(...cards.filter(Boolean));
    status.textContent = items.children.length ? '' : labels.error;
  });

  } catch(e) { console.error(e); }
})();
})();
